export default __webpack_public_path__ + "static/media/dashboard.b6691ee9.svg";